(function () {
    'use strict';

    angular
        .module('app')
        .controller('BuyTicketsController', BuyTicketsController);

    BuyTicketsController.$inject = ['$http', '$state', '$stateParams', '$scope', '$q', '$location', '$rootScope', '$cookies', 'cache', 'dialog', 'eventTracker', 'authenticator'];

    function BuyTicketsController($http, $state, $stateParams, $scope, $q, $location, $rootScope, $cookies, cache, dialog, eventTracker, authenticator) {
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.getVoucher = getVoucher;
        vm.getTotal = getTotal;
        vm.getSubtotal = getSubtotal;
        vm.calculateDiscount = calculateDiscount;
        vm.toCheckout = toCheckout;
        vm.removeVoucher = removeVoucher;
        vm.getOrderFee = getOrderFee;
        vm.lowFiTicketShareInfo = lowFiTicketShareInfo;
        vm.updateAdditionalPurchaseSelection = updateAdditionalPurchaseSelection;

        $scope.range = (start, end, step) => {
            start = parseInt(start);
            end = parseInt(end);
            step = step || 1;
            let length = Math.ceil((end - start + 1) / step);
            let array = Array(length);
            let index = 0;
            for (let value = start; value <= end; value += step) {
                array[index++] = value;
            }
            return array;
        };

        function init() {
            vm.checkout_loading = true;
            vm.vouchers = [];
            vm.discountAmount = 0;
            vm.additional_purchases = '0';
            getConcertDetails().then(function () {
                vm.checkout_loading = false;
            });
            authenticator.checkLoginStatus().then(function(response) {
                vm.isLoggedIn = response;
            })
        }

        function updateAdditionalPurchaseSelection() {
            let additional = parseInt(vm.additional_purchases);
            let tickets = parseInt(vm.ticket_no);
            vm.additional_purchases = `${additional > tickets ? tickets : additional}`;
        }

        function toCheckout() {
            if (vm.checkout_loading) { return; }
            vm.checkout_loading = true;
            var checkoutData = {
                concert_slug: $stateParams.concert_slug,
                ticket_no: vm.ticket_no,
                vouchers: vm.vouchers,
                additional_purchases: vm.additional_purchases
            };
            cache.clear();
            $http.post('/app/api/checkout/create/buy_tickets/', checkoutData)
                .then(function (response) {
                    var checkout_id = parseInt(response.data)
                    if (getTotal() > 0) {
                        vm.checkout_loading = false;
                        eventTracker.addToCart(vm.concert, $stateParams.source_page, vm.ticket_no);
                        $state.go('checkout', { checkout_id: checkout_id, concert: vm.concert, ticket_amount: vm.ticket_no, additional_purchase_amount: vm.additional_purchases });
                    } else {
                        if(vm.isLoggedIn) {
                            var data = {
                                payment_method_id: null,
                                checkout_id: checkout_id
                            }
                            $http.post('api/checkout/pay/', data).then(function (response) {
                                vm.checkout_loading = false;
                                eventTracker.addToCart(vm.concert, $stateParams.source_page, vm.ticket_no);
                                $state.go('ticket_checkout_complete', { checkout_id: checkout_id , concert: vm.concert, ticket_amount: vm.ticket_no });
                            });
                        } else {
                            vm.checkout_loading = false;
                            eventTracker.addToCart(vm.concert, $stateParams.source_page, vm.ticket_no);
                            $state.go('checkout', { checkout_id: checkout_id, concert: vm.concert, ticket_amount: vm.ticket_no, additional_purchase_amount: vm.additional_purchases });
                        }
                    }

                });
        }

        function getTotal() {
            if (!vm.concert.concert_additional_purchase_fee || vm.additional_purchases === '0') {
                return vm.concert ? vm.ticket_no * vm.concert.concert_price - vm.discountAmount + (vm.orderFee * vm.ticket_no): 0;
            } else {
                let additional = parseInt(vm.additional_purchases);
                return vm.concert ? vm.ticket_no * vm.concert.concert_price + additional * vm.concert.concert_additional_purchase_fee - vm.discountAmount + (vm.orderFee * vm.ticket_no) : 0;
            }
        }

        function getSubtotal() {
            if (!vm.concert.concert_additional_purchase_fee || vm.additional_purchases === '0') {
                return vm.concert ? vm.ticket_no * vm.concert.concert_price : 0;
            } else {
                let additional = parseInt(vm.additional_purchases);
                return vm.concert ? vm.ticket_no * vm.concert.concert_price + additional * vm.concert.concert_additional_purchase_fee : 0;
            }
        }

        function getVoucher() {
            vm.checkout_loading = true;
            return $http.post('/app/api/voucher/get/', { code: vm.code, amount: getSubtotal() })
                .then(function (response) {
                    if (response.data == 'FAILED') {
                        vm.voucher_error = "NOT_FOUND";
                    } else {
                        vm.voucher_error = null;
                        response.data.code = vm.code;

                        var codeUsed;
                        vm.vouchers.forEach(voucher => {
                            if (voucher.code == vm.code) {
                                codeUsed = true;
                            }
                        });
                        if (codeUsed) return false;

                        if (response.data.type == 'DISCOUNT_VOUCHER') {
                            vm.hasDiscount = true;
                            vm.vouchers.unshift(response.data);
                        } else if (response.data.type == 'GIFT_VOUCHER') {
                            if (response.data.currency.toLowerCase() != vm.concert.concert_currency.toLowerCase()) {
                                vm.voucher_error = "WRONG_CURRENCY";
                            } else {
                                if (response.data.gift.balance > 0) {
                                    vm.hasDiscount = true;
                                    vm.vouchers.push(response.data);
                                } else {
                                    vm.voucher_error = "ALREADY_USED";
                                }
                            }
                        }
                        vm.togglePromoSection = false;
                        vm.code = "";
                        calculateDiscount();
                    }
                    vm.checkout_loading = false;
                });
        }

        function removeVoucher(voucherToBeRemoved) {
            var new_array = []
            vm.vouchers.forEach(function (voucher) {
                if (voucherToBeRemoved.code != voucher.code) {
                    new_array.push(voucher);
                }
            });
            vm.vouchers = new_array;
            calculateDiscount();
        }

        function calculateDiscount() {
            vm.discountAmount = 0;
            vm.hasDiscount = vm.vouchers.length > 0;
            vm.vouchers.forEach(voucher => {
                if (voucher.type == 'GIFT_VOUCHER') {
                    if (voucher.gift.balance / 100 >= getSubtotal() + vm.orderFee) {
                        voucher.amount = getSubtotal() - vm.discountAmount + vm.orderFee;
                    } else {
                        voucher.amount = voucher.gift.balance / 100;
                    }
                } else if (voucher.type == 'DISCOUNT_VOUCHER') {
                    if(voucher.discount.type == 'PERCENT'){
                        voucher.amount = (voucher.discount.percent_off / 100) * getSubtotal();
                    }
                    if(voucher.discount.type == 'AMOUNT'){
                        voucher.amount = (voucher.discount.amount_off / 100);
                    }
                }
                vm.discountAmount += voucher.amount;
            });
        }

        function getUser() {
            return $http.get('/app/api/private/users/')
                .then(function (response) {
                    vm.user = response.data;
                });
        }

        function getConcertDetails() {
            return $http.get('api/concerts/' + $stateParams.concert_slug + '/')
                .then(function (response) {
                    vm.concert = response.data;

                    /* getBand(vm.details.concert.band.band_slug);
                    getSpace(vm.details.concert.space.space_slug); */
                    build_possible_amount_of_tickets();
                    getOrderFee();
                    sendFacebookAddToCardEvent()
                });
        }

        function sendFacebookAddToCardEvent() {
            return $http.post('api/event/add_to_card/', {value: vm.concert.concert_price, currency: vm.concert.concert_currency, concert_slug: vm.concert.concert_slug})
                .then(function (response) {
                });
        }

        function build_possible_amount_of_tickets() {
            vm.ticket_no = "1";
            vm.possible_amount_of_tickets = [];

            for (var i = 1; i <= vm.concert.remaining_tickets; i++) {
                vm.possible_amount_of_tickets.push(i);
            }
        }

        function getOrderFee(){
            vm.orderFee = 20.00;
        }

        function lowFiTicketShareInfo() {
            dialog.info('low-fi-ticket-share-info');
        }

        function close() {
            eventTracker.removeFromCart(vm.concert, "Upcoming Concerts", vm.ticket_no)
            return $state.go('concert', { concert_slug: $stateParams.concert_slug });
        }

    }
})();
